import React from "react";
import PhotosNVideos from "./PhotosNVideos.jsx";

export default function ProductPictures(props) {
    const { set, variables } = props;

    return (
        <div className="grid-gap-20 align-content-start">
            <PhotosNVideos {...{ set, variables }} />
        </div>
    );
}
